<div class="univ-cat-mark" [attr.data-univ-type]="univMarkType">
  <div class="univ-cat-mark-type">
    {{ univCatType }}
  </div>
  <div class="univ-cat-mark-pref">
    {{ univCatPref }}
  </div>
</div>
